(function() {
  'use strict';

  if (window.__mobileSwiperInitialized) return;
  window.__mobileSwiperInitialized = true;

  var MQ = '(max-width: 749px)';
  var listeners = [];

  function initSwiper(container) {
    var dotsId = container.getAttribute('data-mobile-swiper');
    var dotsContainer = document.querySelector('[data-mobile-swiper-dots="' + dotsId + '"]');
    if (!dotsContainer) return null;

    var dots = dotsContainer.querySelectorAll('.mobile-swiper-dots__dot');
    var slides = container.querySelectorAll('.mobile-swiper__slide');
    if (dots.length === 0 || slides.length === 0) return null;

    var ticking = false;

    function updateDots() {
      var scrollLeft = container.scrollLeft;
      var containerWidth = container.offsetWidth;
      var activeIndex = Math.round(scrollLeft / containerWidth);
      if (activeIndex < 0) activeIndex = 0;
      if (activeIndex >= dots.length) activeIndex = dots.length - 1;

      for (var i = 0; i < dots.length; i++) {
        if (i === activeIndex) {
          dots[i].classList.add('is-active');
        } else {
          dots[i].classList.remove('is-active');
        }
      }
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function() {
          updateDots();
          ticking = false;
        });
        ticking = true;
      }
    }

    function onDotClick(e) {
      var dot = e.target.closest('.mobile-swiper-dots__dot');
      if (!dot) return;
      var index = parseInt(dot.getAttribute('data-dot-index'), 10);
      if (isNaN(index)) return;
      container.scrollTo({
        left: index * container.offsetWidth,
        behavior: 'smooth'
      });
    }

    container.addEventListener('scroll', onScroll, { passive: true });
    dotsContainer.addEventListener('click', onDotClick);

    updateDots();

    return {
      destroy: function() {
        container.removeEventListener('scroll', onScroll);
        dotsContainer.removeEventListener('click', onDotClick);
      }
    };
  }

  function initAll() {
    destroyAll();

    if (!window.matchMedia(MQ).matches) return;

    var swipers = document.querySelectorAll('[data-mobile-swiper]');
    for (var i = 0; i < swipers.length; i++) {
      var instance = initSwiper(swipers[i]);
      if (instance) {
        listeners.push(instance);
      }
    }
  }

  function destroyAll() {
    for (var i = 0; i < listeners.length; i++) {
      listeners[i].destroy();
    }
    listeners = [];
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  var mql = window.matchMedia(MQ);
  if (mql.addEventListener) {
    mql.addEventListener('change', initAll);
  } else if (mql.addListener) {
    mql.addListener(initAll);
  }

  document.addEventListener('shopify:section:load', function() {
    setTimeout(initAll, 100);
  });
})();
